import { localisedValue } from "utils"
import { t } from "i18next"

export const mapSubTaskChildren = (tasks = [], subTaskKeyNameMap, todoLogic) => {
  const map = {}
  tasks?.forEach(subTask => {
    todoLogic[subTask?.key] = subTask?.nextStatus?.todoLogic
    subTaskKeyNameMap[subTask?.key] = subTask?.name
    map[subTask?.key] = subTask?.children || []
  })
  return map
}

const DO_NOTHING_STATUS = () => ({
  id: -1,
  key: "do_nothing",
  name: t("Do Nothing"),
  statusTitleTodo: t("Do Nothing"),
})
const FILTER_KEYS = ["complete_down_payment", "partial_down_payment", "token_payment"]

const getTaskTypeTransformHelper = (response, args) => {
  let subTasksMap = {},
    taskKeyNameMap = {}
  let subTaskChildren = {},
    nextTaskKeyName = {},
    subTaskKeyNameMap = {},
    todoLogic = {}
  const filteredData = response?.leadStatuses.filter(arr => {
    return args?.params?.from === "edit_task" ? arr.key !== "new" : arr.key !== "new" && arr.key !== "sales"
  })
  const filterChildren = (children = [], haveMeetingDonePrivilege) =>
    children?.filter(e => {
      if (e?.key === "meeting_done" || e?.key === "walk_in") {
        return haveMeetingDonePrivilege
      }
      return true
    })
  const data = filteredData.map(e => {
    const taskChildren =
      args?.params?.haveMeetingDonePrivilege === false
        ? filterChildren(e?.children, args?.params?.haveMeetingDonePrivilege)
        : e?.children
    subTaskChildren = mapSubTaskChildren(taskChildren, subTaskKeyNameMap, todoLogic)
    taskKeyNameMap[e?.key] = e?.name
    subTasksMap[e?.key] = { data: taskChildren || [], subOfSubTasks: subTaskChildren }
    return {
      ...e,
      id: e.id,
      name: localisedValue({ object: e, key: "name" }),
      subTask: taskChildren,
      nextTask: e.nextStatus,
    }
  })
  const nextStatus = response?.nextStatuses.map(e => {
    nextTaskKeyName[e?.key] = e?.name
    return {
      ...e,
      name: localisedValue({ object: e, key: "statusTitleTodo" }),
    }
  })

  const nextStatusMap = {
    telesales: () => [...nextStatus],

    sales: () => [DO_NOTHING_STATUS(), ...response?.nextStatuses.filter(e => FILTER_KEYS.includes(e.key))],

    default: () => [DO_NOTHING_STATUS(), ...response?.nextStatuses],
  }

  const typeKey =
    args?.params?.teamType === "telesales" ? "telesales" : args?.extra?.type === "sales" ? "sales" : "default"

  return {
    leadStatuses: data,
    subTasksMap,
    taskKeyNameMap,
    nextTaskKeyName,
    subTaskKeyNameMap,
    todoLogic,
    nextStatuses: nextStatusMap[typeKey](),
  }
}
export default getTaskTypeTransformHelper
